import React, { useState } from 'react';

import Observer from '@researchgate/react-intersection-observer';
import { isNil } from 'ramda';

import Text from 'components/shared/Typography/Text';
import { PLEASE_ENTER_VIDEO_HOST_LINK } from 'constants/texts';
import parseVideoUrl from 'utils/parseVideoUrl';

import styles from './index.module.css';
import { IVideoProps, IVideo } from './types';
import VideoInput from './VideoInput';

function Video(props: IVideoProps) {
  const { source } = props.data?.data;

  if (source) {
    return <VideoPlayer source={source} />;
  }

  return <VideoInput {...props} />;
}

export default Video;

function VideoPlayer({ source }: IVideo) {
  const [isInViewport, setIsInViewport] = useState(false);

  const handleIntersection = (event: IntersectionObserverEntry, unobserve: () => void) => {
    if (event.isIntersecting) {
      setIsInViewport(true);
      unobserve();
    }
  };

  const parsedUrl = parseVideoUrl(source);
  if (isNil(parsedUrl)) {
    return (
      <Text type="danger" size="small" className={styles.error}>
        {PLEASE_ENTER_VIDEO_HOST_LINK}
      </Text>
    );
  }

  return (
    <Observer onChange={handleIntersection}>
      <div className={styles.frame}>{isInViewport && <iframe title="source" allowFullScreen src={parsedUrl} />}</div>
    </Observer>
  );
}
